import Api from './api';

const getSessionId = () => {
    let sessionId = sessionStorage.getItem('visitSessionId');
    if (!sessionId) {
        sessionId = 'sess_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
        sessionStorage.setItem('visitSessionId', sessionId);
    }
    return sessionId;
};

const trackVisit = async (storeId: string) => {
    try {
        const visitTrackedKey = `visitTracked_${storeId}`;
        if (sessionStorage.getItem(visitTrackedKey)) return;

        await Api.post('/visits', {
            storeId,
            sessionId: getSessionId(),
            userAgent: navigator.userAgent,
            referrer: document.referrer || 'direct',
        });

        sessionStorage.setItem(visitTrackedKey, 'true');
    } catch (error) {
        return;
    }
};

const saveAbandonedCart = async (storeId: string, cartData: any) => {
    try {
        const recoveryTokenKey = `cartRecoveryToken_${storeId}`;
        const response = await Api.post('/abandoned-carts', {
            storeId,
            sessionId: getSessionId(),
            recoveryToken: localStorage.getItem(recoveryTokenKey) || undefined,
            ...cartData
        });

        if (response.data?.cart?.recoveryToken) {
            localStorage.setItem(recoveryTokenKey, response.data.cart.recoveryToken);
        }
    } catch (_) {}
};

// Salva carrinho com orderData completo e retorna o _id (usado no fluxo requirePaymentBeforeOrder)
const saveCartWithOrderData = async (storeId: string, cartData: any, orderData: any): Promise<string | null> => {
    try {
        const recoveryTokenKey = `cartRecoveryToken_${storeId}`;
        const response = await Api.post('/abandoned-carts', {
            storeId,
            sessionId: getSessionId(),
            recoveryToken: localStorage.getItem(recoveryTokenKey) || undefined,
            orderData,
            ...cartData
        });

        if (response.data?.cart?.recoveryToken) {
            localStorage.setItem(recoveryTokenKey, response.data.cart.recoveryToken);
        }

        return response.data?.cart?._id?.toString() || null;
    } catch (_) {
        return null;
    }
};

// Função para cancelar/excluir um carrinho abandonado (usada para pedidos normais)
const cancelAbandonedCart = async (sessionId: string) => {
    try {
        await Api.delete(`/abandoned-carts/cancel/${sessionId}`);
    } catch (_) {}
};

const markCartConverted = async (orderId: string, storeId: string) => {
    try {
        const recoveryTokenKey = `cartRecoveryToken_${storeId}`;
        const token = localStorage.getItem(recoveryTokenKey);
        if (!token) return;

        // Só marca como convertido se for uma sessão de recuperação
        const isRecoveredSession = sessionStorage.getItem('isRecoveredSession') === 'true';
        
        if (!isRecoveredSession) {
            localStorage.removeItem(recoveryTokenKey);
            // Opcional: chamar cancelAbandonedCart aqui se desejado, mas o saveAbandonedCart já foi evitado no frontend
            return;
        }

        await Api.patch(`/abandoned-carts/${token}/converted`, { orderId });
        localStorage.removeItem(recoveryTokenKey);
        sessionStorage.removeItem('isRecoveredSession');
    } catch (_) {}
};

const recoverCart = async (token: string, storeId: string) => {
    try {
        const response = await Api.get(`/abandoned-carts/recover/${token}`);
        
        if (response.data?.cart) {
            // Salvar token no localStorage para updates futuros (isolado por loja)
            if (response.data.cart.recoveryToken) {
                const recoveryTokenKey = `cartRecoveryToken_${storeId}`;
                localStorage.setItem(recoveryTokenKey, response.data.cart.recoveryToken);
            }
            return response.data.cart;
        }
        return null;
    } catch (_) { return null; }
};

const checkRecoveryToken = (): string | null => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('recovery');
};

export const TrackingService = {
    trackVisit,
    saveAbandonedCart,
    saveCartWithOrderData,
    markCartConverted,
    recoverCart,
    checkRecoveryToken,
    cancelAbandonedCart,
};
